import { request } from '@/shared/api/request'

export const getSectionAuth = () => {
	return request({ url: `/selftest/auth/get/sections`, method: 'GET' })
}
